export default function () {

	if ( ! $('body').hasClass('home') ) {

		$(window).on('scroll', function(){

			var scrollTop = $(window).scrollTop(),
				oVal = ($(window).scrollTop() / 2000),
				pixs = ($(window).scrollTop() / 100);

			if ( $(window).width() > 768 ) {
			
				$('.about__image').css({
					"webkit-filter": "blur("+pixs+"px)",
					"moz-filter":"blur("+pixs+"px)",
					"ms-filter":"blur("+pixs+"px)",
					"o-filter":"blur("+pixs+"px)",
					"filter":"blur("+pixs+"px)" 
				});

				$('.about__blur').css({
					opacity: oVal
				});

			}

			if ( scrollTop > 1 ) {

				$('.site-header').addClass('fixed');

			} else {

				$('.site-header').removeClass('fixed');

			}

		});

	}

	if ( $('body').hasClass('home') ) {

		$(window).on('scroll', function(){

			var scrollTop = $(window).scrollTop();

			if ( $(window).width() > 768 && $(window).width() < 1200 ) {

				if ( scrollTop > 450 ) {

					$('.site-header').addClass('fixed');

				} else {

					$('.site-header').removeClass('fixed');

				}
			
			}

			if ( $(window).width() > 1200 ) {


				if ( scrollTop > 650 ) {

					$('.site-header').addClass('fixed');

				} else {

					$('.site-header').removeClass('fixed');

				}

			}

		});

	}

}


// WEBPACK FOOTER //
// ./scripts/components/SetupFixedHeader.js